export default (props: { callUnsubcribe: () => void}) => {
  const { callUnsubcribe } = props;
    return (<>
      <div className="col-md-12">
        <p>&nbsp;</p>
        <p>&nbsp;</p>
      </div>
      <div className="col-md-12">
        <div className="media">
          <div className="media-body">
            <h4 className="media-heading">
              <b>Unsubscribe from All Mailings</b>
            </h4>
            <hr/>
            <p>This action will prevent you from receiving any further e-mail communications with RAPS, although you can reverse this decision by resubscribing to any of our communications.</p>
            <div className="text-right">
              <a className="btn btn-danger unsub" style={{ marginRight: "2em"}} onClick={callUnsubcribe}>Unsubscribe All</a>
            </div>
          </div>
        </div>
      </div>
    </>);
  };